<template>
<v-card flat >
  <v-dialog v-model="rangePickerDialog" max-width="300px">
    <v-card>
      <v-card-text>
        <time-range-picker
          class='mt-4'
          v-model='activeRange'
          :min-start-time='minStartTime'
          :initial-start-time='activeStartTime'
          :initial-end-time='activeEndTime' >
        </time-range-picker>
      </v-card-text>
      <v-card-actions>
        <v-btn @click='rangePickerDialog=false' flat>Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn color='primary' v-if='editmode' @click="editHours(activeDay, originalEditRange, activeRange)" :disabled='!activeRange' >Edit</v-btn>
        <v-btn color='primary' v-else @click="addHours(activeDay, activeRange)" :disabled='!activeRange' >Add</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- <pre v-text='hours' ></pre> -->
  <v-card-text v-if='hours' >
    <template v-for='(day, index) in dow' >
      <v-flex xs12 :key='index' >
        <v-list class='elevation-4 mb-4 pa-0' dense >
          <v-subheader class='overline py-0 my-0 grey lighten-2' >{{day}}</v-subheader>
          <v-divider></v-divider>
          <template v-for='(hrSet, index) in getHours(index)' >
            <v-list-item
              v-if='hrSet !== "" && hours[dowLookup[index]]'
              :key='`${hrSet}-${index}`' >
              <v-list-item-content @click='setHours(dowLookup[index], hrSet)' >
                <v-list-item-title>
                  <v-icon small class='mr-2' >mdi-pencil</v-icon> {{hrSet}}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action >
                <v-btn @click='deleteHours(dowLookup[index], hrSet)' icon ><v-icon small>mdi-delete</v-icon></v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-list-item v-else :key='index' >
              <v-list-item-content>
                Not available for appointments
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-layout >
            <v-flex class='justify-right' >
            <v-btn text small @click='showAddHours(dowLookup[index])' >
            <v-icon small class='mr-2'>mdi-plus</v-icon>Add hours</v-btn>
            </v-flex>
          </v-layout>
        </v-list>
      </v-flex>
    </template>
  </v-card-text>
  <v-card-actions >
    <v-spacer />
    <v-btn bottom color='primary' >Save</v-btn>
    <v-btn fab fixed top right
      v-if='withFab' color='primary' >Save</v-btn>
  </v-card-actions>
</v-card>
</template>

<script>
import TimeRangePicker from '@/components/pickers/TimeRangePicker'
export default {
  name: 'OperatingHours',
  components: {TimeRangePicker},
  props: {
    value: { type: Object, default: () => { return {} } },
    withFab: { type: Boolean, default: false }
  },
  data () {
    return {
      rangePickerDialog: false,
      dow: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      dowLookup: ['mon', 'tues', 'wed', 'thurs', 'fri', 'sat', 'sun'],
      activeStartTime: '09:00',
      activeEndTime: '09:00',
      activeRange: null,
      activeDay: null,
      editmode: false,
      originalEditRange: null,
      defaultMinStartTime: '01:00',
      minStartTime: '01:00',
      hours: {}
    }
  },
  mounted () {
    this.hours = this.value
  },
  watch: {
    value () {
      this.hours = this.value
    },
    hours () {
      this.$emit('input', this.hours)
    }
  },
  methods: {
    showAddHours (dayKey) {
      this.activeDay = dayKey
      this.editmode = false
      this.rangePickerDialog = true
      let hrs = this.hours[dayKey]
      if (hrs) {
        let lastRange = hrs.split('|').pop()
        let lastTime = lastRange.split('-').pop()
        this.activeStartTime = lastTime
        this.minStartTime = lastTime
      }
      // this.activeStartTime = startTime
    },
    setHours (dayKey, rangeString) {
      this.activeDay = dayKey
      this.originalEditRange = rangeString
      this.rangePickerDialog = true
      this.editmode = true
      if (rangeString) {
        this.activeStartTime = rangeString.split('-')[0]
        this.activeEndTime = rangeString.split('-')[1]
        this.minStartTime = this.defaultMinStartTime
      }
    },
    getHours (index) {
      try {
        return this.hours[this.dowLookup[index]].split('|')
      } catch (error) {
        return []
      }
    },
    editHours (dayKey, original, newHours) {
      this.hours[dayKey] = this.hours[dayKey].replace(original, newHours)
      this.rangePickerDialog = false
    },
    addHours (dayKey, formattedRange) {
      let hrs = this.hours[dayKey]
      if (hrs.length > 1) {
        this.hours[dayKey] = hrs + '|' + formattedRange
      } else {
        this.hours[dayKey] = formattedRange
      }
      this.rangePickerDialog = false
    },
    deleteHours (dayKey, hourString) {
      let hrs = this.hours[dayKey]
      console.log(hrs, dayKey, hourString)
      hrs = hrs.replace(`|${hourString}|`, '')
      hrs = hrs.replace(`|${hourString}`, '')
      hrs = hrs.replace(`${hourString}`, '')
      this.hours[dayKey] = hrs
    }
  }
}
</script>

<style>

</style>
